import type { VideoOrientation } from '~kui/types/kui';

/**
 * Options for embedded video (e.g. Vimeo). Align with the app’s `VideoOptions` when those change.
 * KUI does not import Phoenix `types/Learn/learningContent` or generated GraphQL.
 */
export interface KUICoreVideoOptions {
  autoplay: boolean;
  orientation: VideoOrientation;
}

export const VIDEO_PROGRESS_MILESTONES = [25, 50, 75, 100] as const;

/** The furthest quartile of a video the viewer has reached, as a percentage. */
export type VideoProgressMilestone = (typeof VIDEO_PROGRESS_MILESTONES)[number];
